import { DataUtil } from "../util/data.util";
import { NumeroUtil } from "../util/numero.util";
import { StringUtil } from "../util/string.util";
import { OrgaoConsulta } from "./orgao-consulta.model";

export class AtoConsulta {

    idAto: number;
    siglaTipoAto: string;
    numeroAto: string;
    orgaosStr?: string;
    dataAtoStr: string;
    dataPublicacaoStr: string;
    republicacao: boolean;
    publicado: boolean;
    internet: boolean;
    flags: string;
    ementa: string;
    orgaos: OrgaoConsulta;

    static getFunctionSortBy(campo: string): (a1: AtoConsulta, a2: AtoConsulta) => number {

        if (campo == 'idAto')
            return (a1: AtoConsulta, a2: AtoConsulta) => NumeroUtil.sort(a1.idAto, a2.idAto);

        if (campo == 'orgaos')
            return (a1: AtoConsulta, a2: AtoConsulta) => StringUtil.sort(a1.orgaosStr, a2.orgaosStr);

        if (campo == 'numeroAto') {
            return (a1: AtoConsulta, a2: AtoConsulta) => {
                if (isNaN(parseInt(a1.numeroAto)) || isNaN(parseInt(a2.numeroAto))
                        || parseInt(a1.numeroAto) == parseInt(a2.numeroAto)) {
                    return StringUtil.sort(a1.numeroAto, a2.numeroAto);
                }
                return NumeroUtil.sort(parseInt(a1.numeroAto), parseInt(a2.numeroAto));
            }
        }

        if (campo == 'tipoAto')
            return (a1: AtoConsulta, a2: AtoConsulta) => StringUtil.sort(a1.siglaTipoAto, a2.siglaTipoAto);

        if (campo == 'dataPublicacao')
            return (a1: AtoConsulta, a2: AtoConsulta) => DataUtil.compareDate(DataUtil.parseStrToDate(a1.dataPublicacaoStr), DataUtil.parseStrToDate(a2.dataPublicacaoStr));

        if (campo == 'dataAto')
            return (a1: AtoConsulta, a2: AtoConsulta) => DataUtil.compareDate(DataUtil.parseStrToDate(a1.dataAtoStr), DataUtil.parseStrToDate(a2.dataAtoStr));

        if (campo == 'publicado')
            return (a1: AtoConsulta, a2: AtoConsulta) => Number(a1.publicado) - Number(a2.publicado);

        if (campo == 'internet')
            return (a1: AtoConsulta, a2: AtoConsulta) => Number(a1.internet) - Number(a2.internet);

        if (campo == 'flags')
            return (a1: AtoConsulta, a2: AtoConsulta) => StringUtil.sort(a1.flags, a2.flags);

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return (a1: AtoConsulta, a2: AtoConsulta) => 0;
    }
}